<template>
    <div class="scc-container">
        <div v-if="sectionTitle !== ''" class="scc-container__row">
            <div class="scc-container__column">
                <Heading tag="h2" class="h1" margin="x-large" :title="sectionTitle"></Heading>
            </div>
        </div>
        <div class="scc-container__row feature-list">
            <template v-for="(feature, i) in features">
                <Feature :key="i" v-bind="featureOptions(feature)" />
            </template>
        </div>
    </div>
</template>

<script>
import './feature-list.scss';
import Heading from './Heading';
import Feature from './Feature';

export default {
    name: 'FeatureList',
    components: { Heading, Feature },
    __editor: {
        fields: {
            features: {
                widget: 'array',
                values: {
                    flat: false,
                    fields: {
                        text: {
                            widget: 'text',
                        },
                        icon: {
                            widget: 'media',
                        },
                        inverted: {
                            widget: 'checkbox',
                        },
                    },
                },
            },
        },
    },
    props: {
        sectionTitle: {
            type: String,
            default: '',
        },
        features: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        featureOptions(feature) {
            const { text, icon, inverted } = feature;

            return {
                text,
                icon,
                inverted,
            };
        },
    },
};
</script>
